export default __webpack_public_path__ + "static/media/fundo-procuracao-mobile.b77cd7db.svg";